/**
 * A horizontal card row keeps sideways swipes and sends an upright wheel to the page.
 * @param {WheelEvent} event
 */
export function releaseVerticalWheel(event) {
  if (!event || event.ctrlKey) return;
  if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
  event.preventDefault();
  const root = document.scrollingElement || document.documentElement;
  root.scrollTop += event.deltaY;
}
